import { createContext, useContext, useState, useCallback } from "react";

// Background-music library. `file` lives in /public/game-assets/.
export const SONGS = [
  { id: "nicaragua", name: "JavyDade - Nicaragua", title: "Nicaragua", artist: "JavyDade", file: "nicaragua-javydade.mp3", spotifyUrl: "https://open.spotify.com/track/0qGtFPfqQBdQ4x4C5XnHth" },
  { id: "jamaica", name: "Angel Mick - Jamaica", title: "Jamaica", artist: "Angel Mick", art: "angelmick.webp", file: "angel-mick-jamaica.mp3", spotifyUrl: "https://open.spotify.com/track/2XpX0NwusBHNtVUEQ5IjcP" },
  { id: "bebiendo", name: "Bebiendo Toda la Noche", title: "Bebiendo Toda la Noche", artist: "Mr Positivity", file: "bebiendo-toda-la-noche.mp3", spotifyUrl: "https://open.spotify.com/track/2cWTChYx7OqX5eQ0FLrFHh" },
  { id: "weekend", name: "Weekend in SJdS", title: "Weekend in San Juan", artist: "Mr Positivity", file: "weekend-in-sjds-remix.mp3", spotifyUrl: "https://open.spotify.com/track/4FKNsxj79lbJGQWpSBT5cD" },
  { id: "fritanga", name: "Fritanga Love", title: "Fritanga Love", artist: "Mr Positivity", file: "fritanga-love-remastered.mp3", spotifyUrl: "https://open.spotify.com/track/2S9uH4zDJlEATDbWQMiF3E" },
  { id: "aguadecoco", name: "Agua de Coco - Costa Azul", title: "Agua de Coco", artist: "Costa Azul", file: "agua-de-coco-costa-azul.mp3", spotifyUrl: "https://open.spotify.com/track/6684odHPP1zTx8N3ygnCpR" },
  { id: "liquor", name: "Ak Dah General - Liquor", title: "Liquor", artist: "Ak Dah General", file: "ak-dah-general-liquor.mp3", spotifyUrl: "https://www.tiktok.com/@nicaflow505" },
];

// Default song for the landing/title screen when the picker is on "auto".
export const LANDING_SONG_ID = "nicaragua";

const MusicContext = createContext(null);

export function MusicProvider({ children }) {
  const [songId, setSongIdState] = useState(() => {
    const saved = localStorage.getItem("nicabros_song");
    if (saved === "auto" || SONGS.some((s) => s.id === saved)) return saved;
    return "auto";
  });
  const setSongId = useCallback((id) => {
    localStorage.setItem("nicabros_song", id);
    setSongIdState(id);
  }, []);
  const current = SONGS.find((s) => s.id === songId) || SONGS[0];
  return <MusicContext.Provider value={{ songId, setSongId, songs: SONGS, current }}>{children}</MusicContext.Provider>;
}

export function useMusic() {
  return useContext(MusicContext);
}
